import { AboutLocalInfo } from "@components/header/about-local-info";
import { Box, Stack } from "@mui/material";
import { DevFeaturesPanel } from "@components/dev-features-dialog/dev-features-panel";

/**
 * Content for the Dev Features Dialog.
 * Displays the features/tools table and app version info.
 */
export function DevFeaturesDialogContent(): JSX.Element {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={2}>
        {/* Dev tools and Features Tables */}
        <DevFeaturesPanel />
        
        {/* App version and commit info for local development */}
        <Box sx={{ mt: 0.25 }}>
          <AboutLocalInfo />
        </Box>
      </Stack>
    </Box>
  );
}
